import React from 'react';
import BottomNav from './BottomNav';
import './Auth.css';

const SearchResult = () => {
  return (
    <div className="auth-container">
      <div style={{display: 'flex', alignItems: 'center', marginBottom: 16}}>
        <input type="text" placeholder="House cleaning" style={{flex: 1}} />
        <button className="auth-btn" style={{marginLeft: 8}}>Filter</button>
      </div>
      <div style={{textAlign: 'left', marginBottom: 8}}>26 results found</div>
      {/* Example worker results */}
      <div className="worker-card">Barnav Basu<br/>Field Work, Kochi<br/>⭐⭐⭐⭐⭐</div>
      <div className="worker-card">Barnav Basu<br/>Field Work, Kochi<br/>⭐⭐⭐⭐⭐</div>
      <BottomNav />
    </div>
  );
};

export default SearchResult; 